/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { SurveyQuestionLeadFieldKind } from './surveyQuestionLeadFieldKind'
import type { SurveyQuestionType } from './surveyQuestionType'

export interface SurveyQuestion {
  updatedAt: string
  createdAt: string
  /**
   * 提示時刻（秒）。null=末尾でまとめて提示 @example 5
   * @nullable
   */
  cueTime: number | null
  /**
   * リード（PII）項目型。非nullなら入力値はリード表へ隔離保存（questionType 無視・ADR-0012） @example "EMAIL"
   * @nullable
   */
  leadFieldKind: SurveyQuestionLeadFieldKind
  required: boolean
  questionType: SurveyQuestionType
  text: string
  order: number
  surveyId: Cuid
  id: Cuid
}
